import React from 'react';
export function SalespersonRequirementTable() {
  return <div className="w-full max-w-full min-w-0 bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden mb-8" data-id="element-482" data-mp="2aok5ki4r2wiy">
      <div className="bg-green-600 px-3 sm:px-6 py-4" data-id="element-483" data-mp="1on724daj3xq5">
        <h3 className="text-xl font-bold text-white" data-id="element-484" data-mp="1omovqnu5k34i">
          Salesperson / Associate Broker — 24 Hour Requirement
        </h3>
        <p className="text-green-100 text-sm mt-1" data-id="element-485" data-mp="vyt1dps22naw">
          24-Hour CE Package — Salesperson & Associate Broker
        </p>
      </div>
      <div className="w-full max-w-full overflow-x-auto [&_td]:px-3 sm:[&_td]:px-6" data-id="element-486" data-mp="rxzacnjbgsds">
        <table className="w-full text-left border-collapse" data-id="element-487" data-mp="15xibgwdpn3gl">
          <tbody data-id="element-488" data-mp="15uw5302k2tzy">
            <tr className="border-b border-gray-100 hover:bg-gray-50" data-id="element-489" data-mp="10xvzeq9mbt9d">
              <td className="px-6 py-3 text-gray-900 font-medium" data-id="element-490" data-mp="10zyv9qxgcgm0">
                Agency Law
              </td>
              <td className="px-6 py-3 text-gray-600 whitespace-nowrap" data-id="element-491" data-mp="2hdyu0ykka07o">
                3 hrs
              </td>
              <td className="px-6 py-3 text-right" data-id="element-492" data-mp="2dt7yh0bq1bii">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-493" data-mp="2dsg0xjykd3pl">
                  Required
                </span>
              </td>
            </tr>
            <tr className="border-b border-gray-100 hover:bg-gray-50" data-id="element-494" data-mp="2np2le7mz9sr3">
              <td className="px-6 py-3 text-gray-900 font-medium" data-id="element-495" data-mp="2soxf0iy50wfu">
                Contract Law
              </td>
              <td className="px-6 py-3 text-gray-600 whitespace-nowrap" data-id="element-496" data-mp="1v4b4kxk8kl0t">
                3 hrs
              </td>
              <td className="px-6 py-3 text-right" data-id="element-497" data-mp="1zzgppu5tdvnu">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-498" data-mp="24zmkhj7drya5">
                  Required
                </span>
              </td>
            </tr>
            <tr className="border-b border-gray-100 hover:bg-gray-50" data-id="element-499" data-mp="1cb73ir4ov5w6">
              <td className="px-6 py-3 text-gray-900 font-medium" data-id="element-500" data-mp="1haa1xsq5ydv6">
                Disclosure
              </td>
              <td className="px-6 py-3 text-gray-600 whitespace-nowrap" data-id="element-501" data-mp="199c77xx72sr9">
                3 hrs
              </td>
              <td className="px-6 py-3 text-right" data-id="element-502" data-mp="14argcp3u1lfh">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-503" data-mp="1izxbo1zjuri3">
                  Required
                </span>
              </td>
            </tr>
            <tr className="border-b border-gray-100 hover:bg-gray-50" data-id="element-504" data-mp="qaq46di4arkp">
              <td className="px-6 py-3 text-gray-900 font-medium" data-id="element-505" data-mp="lcg9e40b1szm">
                Fair Housing
              </td>
              <td className="px-6 py-3 text-gray-600 whitespace-nowrap" data-id="element-506" data-mp="10a8lsnak219l">
                3 hrs
              </td>
              <td className="px-6 py-3 text-right" data-id="element-507" data-mp="vacpzbc0hg54">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-508" data-mp="vcyz3fejw3pg">
                  Required
                </span>
              </td>
            </tr>
            <tr className="border-b border-gray-100 hover:bg-gray-50" data-id="element-509" data-mp="2e9agvgf05lnl">
              <td className="px-6 py-3 text-gray-900 font-medium" data-id="element-510" data-mp="2ebdcqh2u6908">
                Real Estate Legal Issues
              </td>
              <td className="px-6 py-3 text-gray-600 whitespace-nowrap" data-id="element-511" data-mp="258vq41j9recp">
                3 hrs
              </td>
              <td className="px-6 py-3 text-right" data-id="element-512" data-mp="299o1b0bpbtbm">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-513" data-mp="29ah821anuitr">
                  Required
                </span>
              </td>
            </tr>
            <tr className="border-b border-gray-100 hover:bg-gray-50" data-id="element-514" data-mp="320pjlaaoy4zd">
              <td className="px-6 py-3 text-gray-900 font-medium" data-id="element-515" data-mp="2o780fqlx2u9v">
                Requirements for Licensees (formerly Commissioner's
                Standards/Rules)
              </td>
              <td className="px-6 py-3 text-gray-600 whitespace-nowrap" data-id="element-516" data-mp="3fxup996ht1u3">
                3 hrs
              </td>
              <td className="px-6 py-3 text-right" data-id="element-517" data-mp="3kqnqhn2r5s1f">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-518" data-mp="1x1kladzi45xu">
                  Required
                </span>
              </td>
            </tr>
            <tr className="border-b border-gray-100 hover:bg-gray-50" data-id="element-519" data-mp="1n3wlvaqyaa9c">
              <td className="px-6 py-3 text-gray-900 font-medium" data-id="element-520" data-mp="1j1jlz2yvx6kh">
                Firewise, Deed Fraud & Arizona Water
              </td>
              <td className="px-6 py-3 text-gray-600 whitespace-nowrap" data-id="element-521" data-mp="2fq7pyvdrmtaw">
                3 hrs
              </td>
              <td className="px-6 py-3 text-right" data-id="element-522" data-mp="2at7rp6n5quuc">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-50 text-blue-700 border border-blue-200 text-center leading-tight" data-id="element-523" data-mp="2617jkqwxovmo">
                  Required as of 2025
                </span>
              </td>
            </tr>
            <tr className="border-b border-gray-200 hover:bg-gray-50" data-id="element-524" data-mp="2trbr39d8tfiy">
              <td className="px-6 py-3 text-gray-900 font-medium" data-id="element-525" data-mp="2tq0mj7bz43qs">
                Elective (any approved CE topic)
              </td>
              <td className="px-6 py-3 text-gray-600 whitespace-nowrap" data-id="element-526" data-mp="l7h5ritar473">
                3 hrs
              </td>
              <td className="px-6 py-3 text-left whitespace-nowrap" data-id="element-527" data-mp="p8ua1ogqqzbw">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium whitespace-nowrap bg-purple-50 text-purple-700 border border-purple-200" data-id="element-528" data-mp="pbou3evuei4s">
                  Your choice
                </span>
              </td>
            </tr>
            <tr className="bg-gray-50 font-bold" data-id="element-529" data-mp="1451wywjjaeuv">
              <td className="px-6 py-4 text-gray-900 text-right" data-id="element-530" data-mp="18xl69hb6untv">Total</td>
              <td className="px-6 py-4 text-brand-purple-600 whitespace-nowrap" data-id="element-531" data-mp="18zpci5wk7yxb">
                24 hrs
              </td>
              <td data-id="element-532" data-mp="1hy9l2e8eos7t"></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>;
}
export function BrokerRequirementTable() {
  return <div className="w-full max-w-full min-w-0 bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden mb-8" data-id="element-533" data-mp="1mxdw7aew500s">
      <div className="bg-green-600 px-3 sm:px-6 py-4" data-id="element-534" data-mp="3ixwe4kvjuqpy">
        <h3 className="text-xl font-bold text-white" data-id="element-535" data-mp="3e2h3s2wr3cya">
          Designated, Self-Employed & Delegated Associate Brokers — 30 Hour
          Requirement
        </h3>
        <p className="text-green-100 text-sm mt-1" data-id="element-536" data-mp="3nzlrw8a5pihq">
          30-Hour CE Package — Designated & Delegated Brokers
        </p>
        <p className="text-green-100 text-xs mt-0.5 italic" data-id="element-537" data-mp="5kb9ln3p2d9z">
          Includes required Broker Management Clinic (BMC) courses
        </p>
      </div>
      <div className="w-full max-w-full overflow-x-auto [&_td]:px-3 sm:[&_td]:px-6" data-id="element-538" data-mp="1m3okg276psz">
        <table className="w-full text-left border-collapse" data-id="element-539" data-mp="fhfvrmxji8qs">
          <tbody data-id="element-540" data-mp="alh33n56i4kk">
            <tr className="border-b border-gray-100 hover:bg-gray-50" data-id="element-541" data-mp="akywbwkw47ye">
              <td className="px-6 py-3 text-gray-900 font-medium" data-id="element-542" data-mp="2ha3upk35ia0r">
                Agency Law
              </td>
              <td className="px-6 py-3 text-gray-600 whitespace-nowrap" data-id="element-543" data-mp="2cd3w1u8ms9jo">
                3 hrs
              </td>
              <td className="px-6 py-3 text-right" data-id="element-544" data-mp="ru9smea0jj0s">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-545" data-mp="wte4jcobnuut">
                  Required
                </span>
              </td>
            </tr>
            <tr className="border-b border-gray-100 hover:bg-gray-50" data-id="element-546" data-mp="n1zxmju1jsrn">
              <td className="px-6 py-3 text-gray-900 font-medium" data-id="element-547" data-mp="93jsgxbtuabm">
                Contract Law
              </td>
              <td className="px-6 py-3 text-gray-600 whitespace-nowrap" data-id="element-548" data-mp="e2wghlefpnfs">
                3 hrs
              </td>
              <td className="px-6 py-3 text-right" data-id="element-549" data-mp="3vbjnkttnxkq0">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-550" data-mp="3vcupeo3jsieh">
                  Required
                </span>
              </td>
            </tr>
            <tr className="border-b border-gray-100 hover:bg-gray-50" data-id="element-551" data-mp="1yhybr242t4zq">
              <td className="px-6 py-3 text-gray-900 font-medium" data-id="element-552" data-mp="1yg3z0b2ykj6q">
                Disclosure
              </td>
              <td className="px-6 py-3 text-gray-600 whitespace-nowrap" data-id="element-553" data-mp="h9rz2jz8axu7">
                3 hrs
              </td>
              <td className="px-6 py-3 text-right" data-id="element-554" data-mp="cis0796ju5p2">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-555" data-mp="ch795tjg14vy">
                  Required
                </span>
              </td>
            </tr>
            <tr className="border-b border-gray-100 hover:bg-gray-50" data-id="element-556" data-mp="2ij2fqwwsc7k">
              <td className="px-6 py-3 text-gray-900 font-medium" data-id="element-557" data-mp="3un3gq31c5k8p">
                Fair Housing
              </td>
              <td className="px-6 py-3 text-gray-600 whitespace-nowrap" data-id="element-558" data-mp="3pptrandy58kv">
                3 hrs
              </td>
              <td className="px-6 py-3 text-right" data-id="element-559" data-mp="3kstp4nk7wpz1">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-560" data-mp="1nx5k62y6m0zt">
                  Required
                </span>
              </td>
            </tr>
            <tr className="border-b border-gray-100 hover:bg-gray-50" data-id="element-561" data-mp="1qi3kvos4pv88">
              <td className="px-6 py-3 text-gray-900 font-medium" data-id="element-562" data-mp="1vgy770pb21x3">
                Real Estate Legal Issues
              </td>
              <td className="px-6 py-3 text-gray-600 whitespace-nowrap" data-id="element-563" data-mp="208y9v0wrf8xd">
                3 hrs
              </td>
              <td className="px-6 py-3 text-right" data-id="element-564" data-mp="259lyjfxindof">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-565" data-mp="17kkdeplbkknx">
                  Required
                </span>
              </td>
            </tr>
            <tr className="border-b border-gray-100 hover:bg-gray-50" data-id="element-566" data-mp="1hh5ifaxc9vrr">
              <td className="px-6 py-3 text-gray-900 font-medium" data-id="element-567" data-mp="1mhku7y1z2v7m">
                Broker Management Clinic 1 (BMC 1)
              </td>
              <td className="px-6 py-3 text-gray-600 whitespace-nowrap" data-id="element-568" data-mp="2swlpe1j6b9d5">
                3 hrs
              </td>
              <td className="px-6 py-3 text-right" data-id="element-569" data-mp="2xyb3xr5lu55z">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-570" data-mp="rv3mgpnb0yj">
                  Required
                </span>
              </td>
            </tr>
            <tr className="border-b border-gray-100 hover:bg-gray-50" data-id="element-571" data-mp="9konysjy8qj9">
              <td className="px-6 py-3 text-gray-900 font-medium" data-id="element-572" data-mp="eizv2viv0mxs">
                Broker Management Clinic 2 (BMC 2)
              </td>
              <td className="px-6 py-3 text-gray-600 whitespace-nowrap" data-id="element-573" data-mp="3dz6akpodiumb">
                3 hrs
              </td>
              <td className="px-6 py-3 text-right" data-id="element-574" data-mp="3hzgp4qq8etcs">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-575" data-mp="3my0ez27y4paf">
                  Required
                </span>
              </td>
            </tr>
            <tr className="border-b border-gray-100 hover:bg-gray-50" data-id="element-576" data-mp="1279droks0ukp">
              <td className="px-6 py-3 text-gray-900 font-medium" data-id="element-577" data-mp="176mar25d3i10">
                BMC 3 — if brokerage does NOT do property management
              </td>
              <td className="px-6 py-3 text-gray-600 whitespace-nowrap" data-id="element-578" data-mp="2roesljpc83nx">
                3 hrs
              </td>
              <td className="px-6 py-3 text-right" data-id="element-579" data-mp="2msfw18tuvfcf">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-580" data-mp="2hybpgqoi59bv">
                  Required
                </span>
              </td>
            </tr>
            <tr className="border-b border-gray-100 hover:bg-gray-50" data-id="element-581" data-mp="2909q0fkf2oqp">
              <td className="px-6 py-3 text-gray-900 font-medium" data-id="element-582" data-mp="23zc6nzno7onm">
                BMC 3B — if brokerage DOES do property management
              </td>
              <td className="px-6 py-3 text-gray-600 whitespace-nowrap" data-id="element-583" data-mp="1z2c2xveamxzo">
                3 hrs
              </td>
              <td className="px-6 py-3 text-right" data-id="element-584" data-mp="3tejq2mkdiakw">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-585" data-mp="3te09b96gls8g">
                  Required
                </span>
              </td>
            </tr>
            <tr className="border-b border-gray-100 hover:bg-gray-50" data-id="element-586" data-mp="1moyib6pho53q">
              <td className="px-6 py-3 text-gray-900 font-medium" data-id="element-587" data-mp="1rhrrc6rzpzlm">
                Firewise, Deed Fraud & Arizona Water
              </td>
              <td className="px-6 py-3 text-gray-600 whitespace-nowrap" data-id="element-588" data-mp="1cq917g5f2ooj">
                3 hrs
              </td>
              <td className="px-6 py-3 text-right" data-id="element-589" data-mp="25grd96o4c0e3">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-50 text-blue-700 border border-blue-200 text-center leading-tight" data-id="element-590" data-mp="25ham7xvsjefz">
                  Required as of 2025
                </span>
              </td>
            </tr>
            <tr className="bg-gray-50 font-bold" data-id="element-591" data-mp="20gwl6zslx4rg">
              <td className="px-6 py-4 text-gray-900 text-right" data-id="element-592" data-mp="20jiv362yzwcu">Total</td>
              <td className="px-6 py-4 text-brand-purple-600 whitespace-nowrap" data-id="element-593" data-mp="kzcr2naqqy4y">
                30 hrs
              </td>
              <td data-id="element-594" data-mp="p06cna0po0uo"></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>;
}